import React from 'react';
import { SettingsOutlined } from '@mui/icons-material';
import PropTypes from 'prop-types';

const ManageCurrenciesCard = ({ setManageModalState }) => {
    return (
        <div
            onClick={() => {
                setManageModalState(true);
            }}
            className="bg-[#FAFAFA] dark:!bg-[#FFFFFF0A] flex-col justify-center items-center relative rounded-md outline-dashed outline-1 outline-offset-[-1px] outline-zinc-400 dark:outline-[#70707B] max-h-[270px] min-h-[170px] w-full md:w-1/2 lg:w-1/3 px-[2px] mb-1 cursor-pointer hidden lg:flex dark:hover:!bg-[#ffffff14] hover:!bg-[#F4F4F5]">
            <SettingsOutlined className="text-balanceCard-manage" fontSize="large" />
            <p className="text-balanceCard-manage text-xs font-semibold uppercase mt-2">
                Manage currencies
            </p>
        </div>
    );
};

ManageCurrenciesCard.propTypes = {
    setManageModalState: PropTypes.func.isRequired,
};

export default ManageCurrenciesCard;
